import {BaseModel} from "./base-model";
import {PhysicalAsset} from "./physical-asset";
import {Maintenance} from "./maintenance";
import {Equipment} from "./equipment";

export enum EventType {
  EXT_MAINTENANCE,
  SCHEDULED_PROCEDURE,
  TRAINING,
  PLANNED_MAINTENANCE
}

export function EventTypeToString(eventType: EventType) {
  switch (eventType) {
    case EventType.TRAINING:
      return 'Training';
    case EventType.SCHEDULED_PROCEDURE:
      return 'Scheduled procedure';
    case EventType.EXT_MAINTENANCE:
      return 'Extraordinary maintenance';
    case EventType.PLANNED_MAINTENANCE:
      return 'Planned maintenance';
  }
}

export function StringToEventType(eventType: string) {
  return EventType[Object.keys(EventType).find(key => EventType[key] == eventType)];
}

export function EventTypeToColor(eventType: EventType) {
  switch (eventType) {
    case EventType.TRAINING:
      return '#202D85';
    case EventType.SCHEDULED_PROCEDURE:
      return '#0bcf1f';
    case EventType.EXT_MAINTENANCE:
      return '#f60202';
    case EventType.PLANNED_MAINTENANCE:
      return '#f69e02';
  }
}

export interface EventDialog {
  id: string;
  title: string;
  description: string;
  equipmentId: string;
  equipments?: Equipment[];
  assetId: string;
  assets?: PhysicalAsset[];
  type: EventType;
  startDate: Date;
  endDate?: Date;
  trainingUrl?: string;
  accessCode?: string;
  public: boolean;
  remove?: boolean;
  maintenance?: Maintenance;
}

export class CalendarEvent extends BaseModel {

  protected static self = CalendarEvent;

  id: string;
  isPublic: boolean;
  type: EventType;
  typeId: EventType;
  title: string;
  description: string;
  equipmentId: string;
  equipment: PhysicalAsset;
  createdAt: number;
  scheduledAt : number;
  scheduledAtDate: Date;
  endAt: number;
  endAtDate: Date;
  baseTrainingUrl: string;
  trainingUrl: string;
  accessCode: string;
  maintenance: Maintenance;

  public validate(): boolean {
    return true;
  }
}
